import { create } from "zustand";
import { AccountStatus } from "~/types/partners";
import { CreateAccountForm } from "~/types/partners";
import { FlowStep } from "~/types/forms";

const createPartnerStep = [
    {
        id: "create-partner",
        title: "Adding a new partner",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];

const partnerOverviewStep = [
    {
        id: "partner-overview",
        title: "Partner account was succesfully created",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];

const editPartnerStep = [
    {
        id: "edit-partner",
        title: "Editing an existing partner",
        description:
            "Lorem 2 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];

const defaultNewPartner = {
    accountId: "",
    accountName: "",
    homeCountry: { countryIsoCode: "", country: "" },
    countryIsoCode: { countryIsoCode: "", country: "" },
    sapAccountCode: "",
    knowyoursupplierid: "",
    accountType: { accountTypeId: "", accountTypeName: "" },
    accountCity: "",
    accountAddress: "",
    accountPostalCode: "",
    accountStatus: { label: "Active", value: AccountStatus.ACTIVE },
    bankType: "",
    codsId: "",
    alternativeAccountName: undefined,
};
interface CreatePartnerState {
    newPartner: CreateAccountForm;
    setNewPartner: (partner: any) => void;
    editPartnerStep: FlowStep[];
    createPartnerStep: FlowStep[];
    partnerOverviewStep: FlowStep[];
    setSteps: (key: string, steps: FlowStep[]) => void;
    resetPartnerData: () => void;
}

export const useCreatePartnerStore = create<CreatePartnerState>(set => ({
    newPartner: defaultNewPartner as CreateAccountForm,
    setNewPartner: newPartner => set({ newPartner }),
    createPartnerStep,
    partnerOverviewStep,
    editPartnerStep,
    setSteps: (key: string, steps: FlowStep[]) => set({ [key]: steps }),

    resetPartnerData: () =>
        set({
            newPartner: defaultNewPartner as CreateAccountForm,
            createPartnerStep,
            partnerOverviewStep,
            editPartnerStep,
        }),
}));
